import { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import PositionListing from './PositionListing';
import Margin from './Margin';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/js/dist/dropdown';

const exchangeList = [
    { name: 'NSEFO', id: 2 },
    { name: 'NSECD', id: 3 },
    { name: 'MCXFO', id: 51 },
];

const MarginCalculator = () => {
    const [product, setProduct] = useState('futures');
    const [side, setSide] = useState('buy');
    const [type, setType] = useState('put');
    const [symbol, setSymbol] = useState('');
    const [expiry, setExpiry] = useState('');
    const [expStrings, setExpStrings] = useState([]);
    const [qty, setQty] = useState(0);
    const [lotSize, setLotSize] = useState(0);
    const [strikePrices, setStrikePrices] = useState([]);
    const [strikePrice, setStrikePrice] = useState(0);

    const [newstrikePrices, setNewstrikePrices] = useState([]);
    const [newstrikePrice, setNewstrikePrice] = useState(0);

    const [allSymbols, setAllSymbols] = useState([]);
    const [allSymbols1, setAllSymbols1] = useState([]);
    const [symbolDetails, setSymbolDetails] = useState([]);
    const [formattedSymData, setFormattedSymData] = useState({});
    const [exchange, setExchange] = useState(exchangeList[0].id);

    const [positions, setPositions] = useState([]);
    const [margin, setMargin] = useState({});

    const [invalidQty, setInvalidQty] = useState(0);

    const getIntrumentType = (m) => (m === "futures" ? 1 : 2);

    function search(nameKey, myArray){
        for (var i=0; i < myArray.length; i++) {
            if (myArray[i].id == nameKey) {
                return myArray[i].name;
            }
        }
    }
    
    const loadSymbols = () => {
        fetch("https://xts.compositedge.com/marketdata/instruments/instrument/symbol?exchangeSegment=" +
            exchange + "&instrumentType=" + getIntrumentType(product))
            .then(res => res.json())
            .then((data) => {
                const res = [...data.result].sort((a, b) => a.localeCompare(b));
                setAllSymbols(res);
                if (symbol == '') {
                    setSymbol(res[0]);
                    loadSymbolsDetails(symbol);
                } 
                    loadSymbolsDetails(res[0]);
                    setSymbol(res[0]);
                
            },
                (error) => {
                    console.log(error)
                    setAllSymbols([]);
                }
            )
    }


    const loadSymbolsDetails = (symbol) => {
        if (symbol) {
            fetch("https://xts.compositedge.com/marketdata/search/spansearch?source=WEB&searchString=" + symbol)
                .then(res => res.json())
                .then((data) => {
                    var res = data.result.filter(s => s.InstrumentType === getIntrumentType(product) && s.Name === symbol).sort((a, b) => (new Date(a.ContractExpiration).getTime() - new Date(b.ContractExpiration).getTime()))
                    //setAllSymbols1(res);
                    var arr = [];
                    uniqueVal(res, it => it.ContractExpirationString).map(e => {
                        arr.push(e.ContractExpirationString);
                    });
                    setExpStrings(arr);
                    loadSymbolsDetailsValues(res)
                    //setSymbolDetails(res);
                        setExpiry(res[0].ContractExpirationString);
                        setAllSymbols1(res);
                    
                },
                    (error) => {
                        console.log(error)
                        setSymbolDetails([]);
                    }
                )
        }
    }


/********* To get the symbols for the futures and options */
useEffect(() => {
    if(expiry && allSymbols1 != ''){
        var result = allSymbols1.find(item => item.ContractExpirationString === expiry);
        //console.log(result);

        if(getIntrumentType(product) === 1){ // To call the future symbols
            fetch("https://xts.compositedge.com/marketdata/instruments/instrument/futureSymbol?exchangeSegment="+ result.ExchangeSegment +"&series="+ result.Series +"&symbol="+ result.Name +"&expiryDate=" + result.ContractExpirationString)
                .then(res => res.json())
                .then((data) => {
                    var res = data.result;
                    //console.log(res);
                    setSymbolDetails(res);
                },
                (error) => {
                    console.log(error)
                    setSymbolDetails([]);
                });
        } 

        if(getIntrumentType(product) === 2){
            if(newstrikePrice != undefined){
                var typevalue = (type === 'put' ? 'PE' : 'CE');
                fetch("https://xts.compositedge.com/marketdata/instruments/instrument/optionSymbol?exchangeSegment="+ result.ExchangeSegment +"&series="+ result.Series +"&symbol="+ result.Name +"&expiryDate="+ result.ContractExpirationString +"&optionType="+ typevalue +"&strikePrice=" + newstrikePrice)
                .then(res => res.json())
                .then((data) => {
                    var res = data.result;
                    //console.log(res);
                    setSymbolDetails(res);
                },
                (error) => {
                    console.log(error)
                    setSymbolDetails([]);
                });
            }

            }
    }
}, [allSymbols1, expiry, newstrikePrice, type]);

 function loadSymbolsDetailsValues(res) {
    

        //var exp = getexpiry();
        //.log(exp);
       /* if(getIntrumentType(product) === 1){ // To call the future symbols
            fetch("https://xts.compositedge.com/marketdata/instruments/instrument/futureSymbol?exchangeSegment="+  +"&series="+ +"&symbol="+ +"&expiryDate="+20Sep2019)
                .then(res => res.join())
                .then((data) => {});
            
        }*/
        
    }

    const uniqueVal = (data, key) => {
        return [
            ...new Map(
                data.map(x => [key(x), x])
            ).values()
        ]
    }

    const getSymbolData = (exp) => {
        var sarr = symbolDetails.filter((o) => o.ContractExpirationString === exp).sort((a, b) => a.ExchangeInstrumentID - b.ExchangeInstrumentID);
        var dataMap = {};
        sarr.map(s => {
            setQty(s.LotSize);
            setLotSize(s.LotSize);
            if (s.InstrumentType === 1) {
                dataMap["PRICE"] = {
                    'high': s.PriceBand.HighString,
                    'low': s.PriceBand.LowString,
                    'exinstId': s.ExchangeInstrumentID
                };
            } else {
                if (!dataMap[s.StrikePrice]) {
                    dataMap[s.StrikePrice] = {
                        'highCE': s.PriceBand.HighString,
                        'lowCE': s.PriceBand.LowString,
                        'exinstId': s.ExchangeInstrumentID
                    };
                } else {
                    dataMap[s.StrikePrice] = {
                        ...dataMap[s.StrikePrice],
                        'highPE': s.PriceBand.HighString,
                        'lowPE': s.PriceBand.LowString,
                        'exinstId': s.ExchangeInstrumentID
                    };
                }
            }
        });
        return dataMap;
    }

    const initSymbolData = (sy) => {
        if (sy && sy.length > 0) {
            var symData = {};
            uniqueVal(sy, it => it.ContractExpirationString).map(s1 => {
                symData[s1.ContractExpirationString] = getSymbolData(s1.ContractExpirationString);
            });
            setFormattedSymData(symData);
        }
    }

    const updateSymbolData = () => {
        if (formattedSymData && formattedSymData[expiry]) {
            if (getIntrumentType(product) === 2) {
                setStrikePrices(Object.keys(formattedSymData[expiry]));
            }
        }
    }

    const updateQty = (v) => {
        setQty(v);
        console.log(v)
        if (isNaN(parseInt(v))) {
            setInvalidQty(1);
        } else {
            setInvalidQty(0);
        }
    }
    

    useEffect(() => {
        loadSymbolsDetails(symbol);
    }, [symbol]);

    useEffect(() => {
        setStrikePrice(strikePrices[0]);
    }, [strikePrices]);

    useEffect(() => {
        setNewstrikePrice(newstrikePrices[0]);
    }, [newstrikePrices]);

//console.log(strikePrice);
//console.log(newstrikePrice);

    useEffect(() => {
        if(allSymbols1 != '' && getIntrumentType(product) === 2){
            var resultsp = allSymbols1.filter((item) => item.ContractExpirationString === expiry);
            var skprice = uniqueVal(resultsp, it => it.StrikePrice);
            var sortskprice = [...skprice].sort((a, b) => a.StrikePrice - b.StrikePrice);
            var ids = sortskprice.map( (item) => item.StrikePrice);
            const arrOfStr = ids.map(num => {
                return String(num);
              });
            var strkp = arrOfStr;
            setNewstrikePrices(strkp);
            //
        }
    }, [allSymbols1, expiry]);

    useEffect(() => {
        updateSymbolData();
    }, [expiry, formattedSymData]);

    useEffect(() => {
        loadSymbols();
    }, [exchange, product]);

   /* useEffect(() => {
        loadSymbolsValues(expiry);
    }, [expiry]); */

    useEffect(() => {
            initSymbolData(symbolDetails);
    }, [symbolDetails]);

    useEffect(() => {
        loadMargin();
    }, [positions]);

    
    
    const positionExist = (val) => {
        return positions.some((pos) => pos.exInstrumentId  === val.exInstrumentId ); 
      }

    const addPosition = () => {
        if (qty % lotSize === 0 && qty > 0) {
            var position = {
                'exchange': search(exchange, exchangeList),
                'exInstrumentId': getIntrumentType(product) === 1 ? formattedSymData[expiry].PRICE.exinstId : formattedSymData[expiry][strikePrice].exinstId,
                'product': product,
                'ticker': symbol,
                'expiry': expiry,
                'option': getIntrumentType(product) === 1 ? 0 : strikePrice + (type === 'put' ? 'PE' : 'CE'),
                'qty': side === 'buy' ? qty : qty * -1,
                'price': getIntrumentType(product) === 1 ? formattedSymData[expiry].PRICE.high : (type === 'put' ? formattedSymData[expiry][strikePrice].highPE : formattedSymData[expiry][strikePrice].highCE),
                'span': 0,
                'exposure': 0,
                'total': 0
            };
            if (!positionExist(position)) {
                let posArr = [...positions, position];
                setPositions(posArr);
            }
        } else {
            setInvalidQty(1);
        }
    }

    const removePosition = (key) => {
        setPositions(positions.filter(p => p.exInstrumentId !== key ))
      }

      const removeAllPosition = () => {
        setPositions([]);
      };

    const loadMargin = () => {
        let portArr = []
        positions.forEach((p) => {
            const pos = { "Exchange": p.exchange, "ExchangeInstrumentID": p.exInstrumentId, "Position": p.qty, "Price": p.price }
            portArr = [...portArr, pos];
        });
        fetch("https://xts.compositedge.com/marketdata/instruments/calculator/position", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "Portfolio": portArr
            })
        }).then(res => res.json())
            .then((data) => {
                setMargin(data.result);
            },
                (error) => {
                    console.log(error)
                    setMargin({
                        SpanMargin: 0.00,
                        ExposureMargin: 0.00,
                        NetOptionsPremium: 0.00,
                        TotalMargin: 0.00
                    })
                    
                }
            )
    }

/*if(getIntrumentType(product) === 2){
    if(allSymbols1 !== '' ){
    var symb = allSymbols1.filter(s => s.InstrumentType === '2');
    console.log(symb);
    var skprice = uniqueVal(allSymbols1, it => it.StrikePrice);
    var sortskprice = [...skprice].sort((a, b) => a.StrikePrice - b.StrikePrice);
    var resultsp = sortskprice.map(a => a.StrikePrice);
    //console.log(resultsp);
    }
}*/


    return (
        <>
            <Container>
                <Row>
                    <Col sm>
                        <Form.Label htmlFor="exchange">Exchange</Form.Label>
                        <Form.Select id="exchange" aria-label="Select exchange" className='form-control'
                            onChange={(e) => { setSymbol(''); setExpiry(''); setExchange(e.currentTarget.value) }}>
                            {exchangeList.map((e, i) => (
                                <option key={i} value={e.id}>{e.name}</option>
                            ))}
                        </Form.Select></Col>
                    <Col sm>
                        <Form.Label htmlFor="symbol">Symbol</Form.Label>
                        <Form.Select id="symbol" aria-label="Select symbol" className='form-control'
                            onChange={(e) => { setExpiry(''); setSymbol(e.currentTarget.value) }} value={symbol}>
                            {allSymbols.map((s, i) => (
                                <option key={i} value={s}>{s}</option>
                            ))}
                        </Form.Select></Col>
                    <Col sm>
                        <Form.Label htmlFor="expiry">Expiry</Form.Label>
                        <Form.Select id="expiry" aria-label="Select expiry" className='form-control'
                            onChange={(e) => setExpiry(e.currentTarget.value)} value={expiry}>
                            {expStrings.map((s, i) => (
                                <option key={i} value={s}>{s}</option>
                            ))}
                        </Form.Select></Col>
                </Row>
                <Row>
                    <Col></Col>
                </Row>
                <Row id="reacrow">
                    <Col sm id="reactfno">Product: <Form.Check
                        onChange={() => setProduct('futures')}
                        inline
                        label="Futures"
                        name="product"
                        type="radio"
                        id={`futures`}
                        checked={product === 'futures'}
                    />
                        <Form.Check
                            onChange={() => setProduct('options')}
                            inline
                            label="Options"
                            name="product"
                            type="radio"
                            id={`options`}
                            checked={product === 'options'}
                        />
                        {product === 'options' ? <div className='mt-2' id="reacttype">
                            Type: <Form.Check
                                onChange={() => setType('call')}
                                inline
                                label="Call"
                                name="type"
                                type="radio"
                                id={`call`}
                                checked={type === 'call'}
                            />
                            <Form.Check
                                onChange={() => setType('put')}
                                inline
                                label="Put"
                                name="type"
                                type="radio"
                                id={`put`}
                                checked={type === 'put'}

                            /></div> : ''}
                    </Col>
                    {product === 'options' ?
                        <Col sm>
                            <Form.Label htmlFor="strikePrice">Strike price</Form.Label>
                            <Form.Select id="strikePrice" aria-label="Select Strike Price" className='form-control'
                                onChange={(e) => setNewstrikePrice(e.currentTarget.value)} value={newstrikePrice}>
                                {newstrikePrices.map((s, i) => (
                                    <option key={i} value={s}>{s}</option>
                                ))}
                            </Form.Select>
                        </Col> : <Col sm></Col>}

                    <Col sm id="reactside">Side: <Form.Check
                        onChange={() => setSide('buy')}
                        inline
                        label="Buy"
                        name="side"
                        type="radio"
                        id={`buy`}
                        checked={side === 'buy'}
                    />
                        <Form.Check
                            onChange={() => setSide('sell')}
                            inline
                            label="Sell"
                            name="side"
                            type="radio"
                            id={`sell`}
                            checked={side === 'sell'}
                        /></Col>
                    <Col sm>
                        <Form.Label htmlFor="qty">Net Quantity (Lot size {lotSize})</Form.Label>
                        <Form.Control
                            type="number"
                            id="qty"
                            value={qty}
                            step={lotSize}
                            className={`${invalidQty === 1 ? 'invalid' : ''} `}
                            onChange={(e) => { updateQty(e.currentTarget.value) }}
                        /></Col>
                </Row>

                <Row>
                    <Col className="my-3 text-right">
                        <Button variant="primary" onClick={() => addPosition()}>Add</Button>{' '}
                        <Button variant="primary" onClick={() => removeAllPosition()} className='bg-light text-primary'>Reset</Button>{' '}
                    </Col>
                </Row>

            </Container>
            <Container className="pos-list">
                <PositionListing positions={positions} removePosition={removePosition} marginvalue={margin} />
            </Container>

            <Container className="pos-list">
                <h3 className='mt-5 mb-3'>Required Margin for This Strategy</h3>
                <Margin margin={margin} />
            </Container>
        </>
    );
}

export default MarginCalculator